// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".highlighted-links-inside-article__item[data-v-377eabaa]{margin:16px 0 0}.highlighted-links-inside-article__link[data-v-377eabaa]{color:#444;font-weight:600;-webkit-text-decoration-line:underline;text-decoration-line:underline;-webkit-text-decoration-color:#ffeb3b;text-decoration-color:#ffeb3b;text-decoration-thickness:4px;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}.highlighted-links-inside-article__link[data-v-377eabaa]:hover{color:#1335f5}", ""]);
// Exports
module.exports = exports;
